// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GQHUj","footer":"styles_footer__3yecb","passCodeTooltip":"styles_passCodeTooltip__3NwOZ"};